import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import LocationList from '@/resources/LocationList.json'
import DetailInfoModal from '@/views/DetailInfoModal'

type Props = {
  isOpen: boolean
  mapCode: number
  closeModal: () => void
}

const OverWorldModal = ({ isOpen, mapCode, closeModal }: Props) => {
  // #region フック

  const [isDisplayCross, setIsDisplayCross] = useState<boolean>(false)
  const [isDetailOpen, setIsDetailOpen] = useState<boolean>(false)
  useEffect(() => {
    const interval = setInterval(() => {
      setIsDisplayCross((previousState) => !previousState)
    }, 500)
    return () => clearInterval(interval)
  }, [])

  // #endregion フック

  // #region スタイル

  const modalStyle: Modal.Styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(240,240,240,0.7)'
    },
    content: {
      position: 'absolute',
      backgroundColor: '#f0f0f0',
      border: 'solid 1px #000000',
      top: '10px',
      left: '17%',
      right: '17%',
      bottom: '10px',
      padding: '0px'
    }
  }

  const headerStyle: React.CSSProperties = {
    margin: '5px 0px 0px 10px'
  }

  const mainStyle: React.CSSProperties = {
    margin: '0px 10px 10px 10px'
  }

  const contentStyle: React.CSSProperties = {
    position: 'relative'
  }

  const overWorldStyle: React.CSSProperties = {
    height: '800px'
  }

  const crossStyle: React.CSSProperties = {
    width: '25px',
    height: '25px',
    position: 'absolute',
    left: `${LocationList['grotto-locations'][mapCode - 1]?.position.x}px`,
    top: `${LocationList['grotto-locations'][mapCode - 1]?.position.y}px`,
    visibility: isDisplayCross ? 'visible' : 'hidden'
  }

  const buttonsStyle: React.CSSProperties = {
    textAlign: 'right'
  }

  const buttonMarginStyle: React.CSSProperties = {
    marginRight: '10px'
  }

  // #endregion スタイル

  // #region イベント

  const openDetailModal = () => {
    setIsDetailOpen(true)
  }

  const closeDetailModal = () => {
    setIsDetailOpen(false)
  }

  // #endregion イベント

  return (
    <Modal isOpen={isOpen} ariaHideApp={false} style={modalStyle}>
      <h1 style={headerStyle}>位置情報</h1>
      <main style={mainStyle}>
        <div style={contentStyle}>
          <img style={overWorldStyle} src={`images/overworld.jpg`} />
          <img style={crossStyle} src={`images/cross.png`} />
        </div>
        <div style={buttonsStyle}>
          <button style={buttonMarginStyle} onClick={openDetailModal}>
            詳細情報
          </button>
          <DetailInfoModal isOpen={isDetailOpen} mapCode={mapCode} closeDetailModal={closeDetailModal} />
          <button onClick={closeModal}>閉じる</button>
        </div>
      </main>
    </Modal>
  )
}

export default OverWorldModal
